import { createColumnHelper } from '@tanstack/react-table';
import { truncate } from 'lodash-es';

import type {
  DriverRead,
  PreferenceTypeEnum,
  PreferredDriverRead,
} from 'src/common/external/bambi-api/bambiApi';

import { ManageCell } from './ManageCell';

const columnHelper = createColumnHelper<PreferredDriverRead>();

const preferenceTypeLabels: Record<PreferenceTypeEnum, string> = {
  prefer: 'Prefer',
  avoid: 'Avoid',
  demand: 'Demand',
  prohibit: 'Prohibit',
};

export function createColumns(
  driverNameLookup: Record<string, string>,
  passengerId: string,
  drivers: DriverRead[]
) {
  return [
    columnHelper.accessor('driver', {
      id: 'driver',
      header: 'Driver',
      cell: ({ getValue }) => driverNameLookup[getValue()] ?? getValue(),
      meta: { enableHeaderMenu: false },
    }),
    columnHelper.accessor('preference_type', {
      id: 'preference_type',
      header: 'Preference',
      cell: ({ row }) => preferenceTypeLabels[row.original.preference_type],
      meta: { enableHeaderMenu: false },
    }),
    columnHelper.accessor('notes', {
      id: 'notes',
      header: 'Notes',
      cell: ({ row }) => truncate(row.original.notes ?? '-', { length: 75 }),
      meta: { enableHeaderMenu: false },
    }),
    columnHelper.display({
      id: 'actions',
      header: 'Manage',
      cell: ({ row }) => (
        <ManageCell
          preferredDriver={row.original}
          passengerId={passengerId}
          drivers={drivers}
        />
      ),
      meta: { enableHeaderMenu: false },
    }),
  ];
}
